
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/[[...path]]",
      function () {
        return require("private-next-pages/onboarding/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding/[[...path]]"])
      });
    }
  